module.exports = __webpack_public_path__ + "static/img/store3.34a5749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/store3.jpg
// module id = MLY1
// module chunks = 1